import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "article-gate-readiness",
  "data-testid": "marketing-article-gate-readiness",
  role: "note"
}
const _hoisted_2 = {
  key: 0,
  class: "article-gate-readiness-more"
}
const _hoisted_3 = { class: "article-gate-readiness-location" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.readiness && _ctx.readiness.blocked_count > 0)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("strong", null, "提案は始められますが、公開前ゲートで止まる可能性があります（" + _toDisplayString(_ctx.readiness.blocked_count) + " / " + _toDisplayString(_ctx.readiness.total) + "キーワード）", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.readiness.note), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleKeywords, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.keyword
            }, [
              _createElementVNode("span", null, _toDisplayString(item.keyword), 1),
              _createTextVNode("：不足 " + _toDisplayString(item.missing_labels.join("、")), 1)
            ]))
          }), 128))
        ]),
        (_ctx.hiddenCount > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "ほか" + _toDisplayString(_ctx.hiddenCount) + "件", 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_3, "入力場所：" + _toDisplayString(_ctx.readiness.setting_location), 1)
      ]))
    : _createCommentVNode("", true)
}